<h1 mat-dialog-title>Deletar</h1>
<div mat-dialog-content>
  Você tem certeza que deseja deletar?
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Não</button>
  <button mat-button (click)="onYesClick()" cdkFocusInitial>Sim</button>
</div>